<template>
<div>
    <div><h3>Organization</h3></div>
    <div class="wrapper">
        <div class="row row-wider">
            <div class="col-md-12" style="min-height: 150px;">
                <loader v-if="isLoading"/>
                <h4>Existing Organization</h4>
                <v-client-table :data="organizationGridSpec.tableData" :columns="organizationGridSpec.columns" :options="organizationGridSpec.options">
                    <template slot="edit" slot-scope="props">
                        <div style="text-align: center">
                            <a  class="fa fa-edit" style="font-size: 18px;" v-on:click="editOrganization(props.row)"></a>
                        </div>
                    </template>
                </v-client-table>
                <button class="btn btn-primary pull-right" v-on:click="clearOrganization()">Add New</button>
                <div>
                    <h4>Organization</h4>
                </div>
                <form v-on:submit.prevent class="form form-horizontal" data-vv-scope="addOrganization" ref="editForm">
                    <div class="form-group">
                        <label class="col-md-3 control-label">Name</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" v-model="organization.description" placeholder="Organization Name" v-validate="'required'">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">Address Street 1</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" v-model="organization.addressStreet1" placeholder="Address Street Line 1">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">Address Street 2</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" v-model="organization.addressStreet2" placeholder="Address Street Line 2">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">Address Street 3</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" v-model="organization.addressStreet3" placeholder="Address Street Line 3">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">City</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" v-model="organization.addressCity" placeholder="City">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">State</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" v-model="organization.addressState" placeholder="State">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">Zip</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" v-model="organization.addressZip" placeholder="Zip">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">Billing Code</label>
                        <div class="col-md-4">
                            <select class="form-control" v-model="organization.billingCodeId">
                                <option disabled value="">Select a value</option>
                                <option v-for="code in billingCodeList" :key="code.billingCodeId" v-bind:value="code.billingCodeId">
                                    {{code.description}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">Shape File Access Restricted?</label>
                        <div class="col-md-1">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input id="shapeFileRestricted" type="checkbox" v-model="organization.isShapeFileRestricted" />
                                <label for="shapeFileRestricted">&nbsp;</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">Client</label>
                        <div class="col-md-1">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input id="clientCB" type="checkbox" v-model="organization.isClient" />
                                <label for="clientCB">&nbsp;</label>
                            </div>
                        </div>
                        <label class="col-md-3 control-label">Consultant</label>
                        <div class="col-md-1">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input id="consultantCB" type="checkbox" v-model="organization.isConsultant" />
                                <label for="consultantCB">&nbsp;</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">BLM Field Office</label>
                        <div class="col-md-1">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input id="blmFieldOfficeCB" type="checkbox" v-model="organization.isBlmFieldOffice" />
                                <label for="blmFieldOfficeCB">&nbsp;</label>
                            </div>
                        </div>
                        <label class="col-md-3 control-label">BLM District Office</label>
                        <div class="col-md-1">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input id="blmDistrictOfficeCB" type="checkbox" v-model="organization.isBlmDistrictOffice" />
                                <label for="blmDistrictOfficeCB">&nbsp;</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">BLM State Office</label>
                        <div class="col-md-1">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input id="blmStateOfficeCB" type="checkbox" v-model="organization.isBlmStateOffice" />
                                <label for="blmStateOfficeCB">&nbsp;</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">USFS Field Office</label>
                        <div class="col-md-1">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input id="usfsFieldOfficeCB" type="checkbox" v-model="organization.isUsfsFieldOffice" />
                                <label for="usfsFieldOfficeCB">&nbsp;</label>
                            </div>
                        </div>
                        <label class="col-md-3 control-label">USFS Regional Office</label>
                        <div class="col-md-1">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input id="usfsRegionOfficeCB" type="checkbox" v-model="organization.isUsfsRegionOffice" />
                                <label for="usfsRegionOfficeCB">&nbsp;</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">Lead Agency</label>
                        <div class="col-md-1">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input id="leadAgencyCB" type="checkbox" v-model="organization.isLeadAgency" />
                                <label for="leadAgencyCB">&nbsp;</label>
                            </div>
                        </div>
                        <label class="col-md-3 control-label">106 Agency</label>
                        <div class="col-md-1">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input id="onezerosixCB" type="checkbox" v-model="organization.is106Agency" />
                                <label for="onezerosixCB">&nbsp;</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">Agency No Review</label>
                        <div class="col-md-1">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input id="reviewingAgencyCB" type="checkbox" v-model="organization.agencyNoReview" />
                                <label for="reviewingAgencyCB">&nbsp;</label>
                            </div>
                        </div>
                        <label class="col-md-3 control-label">Federal Agency</label>
                        <div class="col-md-1">
                            <div class="checkbox checkbox-inline" style="padding-top:0px">
                                <input id="fedAgencyCB" type="checkbox" v-model="organization.isFederalAgency" />
                                <label for="fedAgencyCB">&nbsp;</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" style="margin-top: 10px;">
                        <label class="col-md-3 control-label">Users</label>
                        <div class="col-md-7">
                            <v-client-table :data="userGridSpec.tableData" :columns="userGridSpec.columns" :options="userGridSpec.options">
                                <template slot="edit" slot-scope="props">
                                    <div style="text-align: center">
                                        <a  class="fa fa-edit" style="font-size: 18px;" v-on:click="goUser(props.row)"></a>
                                    </div>
                                </template>
                            </v-client-table>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-1">
                            <button class="btn btn-primary pull-right" v-on:click="addOrganization">Save</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import organizationService from '@/services/organizationService'
import loggingService from '@/services/util/loggingService'
import userService from '@/services/userService'

import loader from '@/components/Loader'

export default {
    components: {
        loader
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            organization: {},
            billingCodeList: [],
            organizationGridSpec: {
                columns: ['edit', 'description'],
                options: {
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        edit: 'View/Edit',
                        description: 'Org. Name'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'description'
                    }
                },
                tableData: []
            },
            userGridSpec: {
                columns: ['edit', 'name', 'firstName', 'lastName'],
                options: {
                    perPage: 10,
                    perPageValues: [5, 10, 25],
                    headings: {
                        edit: 'Go to',
                        name: 'Username',
                        description: 'User Email',
                        firstName: 'First Name',
                        lastName: 'Last Name'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'name'
                    }
                },
                tableData: []
            }
        }
    },
    mounted () {
        this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Organization', message)
        },
        loadData () {
            this.isLoading = true
            organizationService.list(this.$http).then(result => {
                this.organizationGridSpec.tableData = result.data
                this.isLoading = false
            })
            this.billingCodeList = organizationService.getBillingCodeList()
        },
        editOrganization (selectedOrg) {
            this.isLoading = true
            this.log('selected org billingcode :' + selectedOrg.billingCodeId)
            this.organization = selectedOrg
            //load users attached to this org
            userService.listUserResultsByOrg(this.$http, this.organization.organizationId).then(res => {
                this.userGridSpec.tableData = res.data
                this.isLoading = false
            })
        },
        clearOrganization () {
            this.organization = {
                billingCodeId: ''
            }
            this.userGridSpec.tableData = []
        },
        addOrganization () {
            this.$validator.validateAll('addOrganization').then(result => {
                if (!result) {
                    return
                }
                organizationService.put(this.$http, this.organization).then(result2 => {
                    this.$router.go()
                })
            })
        },
        goUser (user) {
            this.$router.push(`UserAdministration?userId=${user.userId}`)
        }
    }
}
</script>



// WEBPACK FOOTER //
// Organization.vue?1403ef12